import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const appRoutes: Routes = [
  { path: "", redirectTo: "auth/login", pathMatch: "full" },
  {
    path: "auth",
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
    data: {
      preload: false,
    },
  },
  {
    path: "",
    loadChildren: () =>
      import("./favorites/favorites.module").then((m) => m.FavoritesModule),
    // canActivate: [AuthGuard],
    data: {
      preload: true,
    },
  },
  {
    path: "**",
    // component: ErrorPageComponent,
    // data: { title: "Page Not Exist" },
    // canActivate: [WildCardRouteGuard],
    redirectTo: "auth/login"
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
